import React from "react";
import { FormattedMessage } from "react-intl";
import { Button } from "@material-ui/core";
import { Refresh, Home } from "@material-ui/icons";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log the error to console for debugging
    console.error("[ErrorBoundary] Caught error:", error);
    console.error("[ErrorBoundary] Error info:", errorInfo);
    
    this.setState({
      error: error,
      errorInfo: errorInfo,
    });

    // You can also log the error to an error reporting service here
    // e.g., Sentry, LogRocket, etc.
  }

  handleRefresh = () => {
    window.location.reload();
  };

  handleGoHome = () => {
    window.location.href = "/";
  };

  handleRetry = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
  };

  render() {
    if (this.state.hasError) {
      // Custom fallback UI
      if (this.props.fallback) {
        return this.props.fallback;
      }

      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "400px",
            padding: "40px",
            textAlign: "center",
            backgroundColor: "#f8f9fa",
            borderRadius: "8px",
            margin: "20px",
          }}
        >
          <div
            style={{
              fontSize: "64px",
              marginBottom: "20px",
            }}
          >
            ⚠️
          </div>
          <h2
            style={{
              color: "#343a40",
              marginBottom: "16px",
              fontSize: "24px",
            }}
          >
            <FormattedMessage
              id="error.page_crashed"
              defaultMessage="Something went wrong"
            />
          </h2>
          <p
            style={{
              color: "#6c757d",
              marginBottom: "24px",
              maxWidth: "500px",
            }}
          >
            <FormattedMessage
              id="error.page_crashed_description"
              defaultMessage="An unexpected error occurred. Please try refreshing the page or go back to the home page."
            />
          </p>

          {process.env.REACT_APP_ENV === "development" && this.state.error && (
            <details
              style={{
                marginBottom: "24px",
                padding: "16px",
                backgroundColor: "#fff3cd",
                borderRadius: "4px",
                maxWidth: "600px",
                width: "100%",
                textAlign: "left",
              }}
            >
              <summary style={{ cursor: "pointer", fontWeight: "bold" }}>
                Error Details (Development Only)
              </summary>
              <pre
                style={{
                  marginTop: "12px",
                  fontSize: "12px",
                  overflow: "auto",
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-word",
                }}
              >
                {this.state.error.toString()}
                {this.state.errorInfo?.componentStack}
              </pre>
            </details>
          )}

          <div style={{ display: "flex", gap: "12px" }}>
            <Button
              variant="contained"
              color="primary"
              startIcon={<Refresh />}
              onClick={this.handleRetry}
              style={{ textTransform: "capitalize" }}
            >
              <FormattedMessage id="button.retry" defaultMessage="Try Again" />
            </Button>
            <Button
              variant="outlined"
              startIcon={<Refresh />}
              onClick={this.handleRefresh}
              style={{ textTransform: "capitalize" }}
            >
              <FormattedMessage
                id="button.refresh"
                defaultMessage="Refresh Page"
              />
            </Button>
            <Button
              variant="outlined"
              startIcon={<Home />}
              onClick={this.handleGoHome}
              style={{ textTransform: "capitalize" }}
            >
              <FormattedMessage id="button.home" defaultMessage="Go Home" />
            </Button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
